/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Obligations_S42_Item_5Inputs */

const es_tyc_obligations_s42_item_5 = /** @type {(inputs: Tyc_Obligations_S42_Item_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interferir con el operativo de Nexata o fuentes de otros Usuarios.`)
};

const en_tyc_obligations_s42_item_5 = /** @type {(inputs: Tyc_Obligations_S42_Item_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interfere with the operation of Nexata or other Users sources.`)
};

/**
* | output |
* | --- |
* | "Interfere with the operation of Nexata or other Users sources." |
*
* @param {Tyc_Obligations_S42_Item_5Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_obligations_s42_item_5 = /** @type {((inputs?: Tyc_Obligations_S42_Item_5Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Obligations_S42_Item_5Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_obligations_s42_item_5(inputs)
	return en_tyc_obligations_s42_item_5(inputs)
});
export { tyc_obligations_s42_item_5 as "tyc.obligations.s42_item_5" }